import React from "react";

const RadioImageQuestion = ({ question, value = "", onChange }) => {
    return (
        <div className="radio-image-question">
            <div className="chat-message system">
                {question.label}
            </div>
            <div className="radio-image-options">
                {question.answers.map((option) => {
                    const isSelected = value === option.label;

                    return (
                        <button
                            key={option.ans_id}
                            className={`btn chat-answer-option ${isSelected ? "selected" : ""}`}
                            onClick={() => onChange(option.label)}
                        >
                            {option.image && (
                                <img src={option.image} alt={option.label} className="option-image" />
                            )}
                            <span>{option.label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default RadioImageQuestion;
